export default "__VITE_ASSET__36IOQTVB__"